import { atom, useAtomValue, useSetAtom } from 'jotai'
import { atomFamily } from 'jotai/utils'
import type { RestaurantId } from '~/lib/graphql/scalars'

const reservable = atomFamily((id: RestaurantId) => atom<boolean | undefined>(undefined))

export function useReservable(id: RestaurantId) {
  return useAtomValue(reservable(id))
}

export function useSetReservable(id: RestaurantId) {
  return useSetAtom(reservable(id))
}
